import script from "./WechatPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatPopup.vue?vue&type=script&setup=true&lang=js"

import "./WechatPopup.vue?vue&type=style&index=0&id=6283f8d0&lang=less&scoped=true"

import exportComponent from "/Users/beiyu/Documents/web/森瑶/web/senyao-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6283f8d0"]])

export default __exports__